import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetCountryRegionListRequest extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("countryregion.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "ListCountryRegionResult";
    }
}

export default GetCountryRegionListRequest;
